import { CheckIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import { Spinner } from '@/shared/components/ui/spinner'
import { cn } from '@/shared/lib/utils'

import { useApproveAnchorFamily } from '../../lib/useApproveAnchorFamily'
import { useApprovalPageContext } from '../ApprovalPageProvider'

export default function AnchorFamilyApproveButton({ id }: { id: string }) {
	const { t } = useTranslation()

	const { handleApproveAnchorFamily, isPending } = useApproveAnchorFamily()
	const { isMutationPending } = useApprovalPageContext()

	return (
		<Button
			disabled={isMutationPending}
			data-testid='approve-button'
			//fix when a success variant is implemented
			className={cn(
				'dark:text-success-200 bg-success text-white hover:bg-success/90 hover:text-white dark:bg-success/90 dark:hover:bg-success/80'
			)}
			onClick={() => handleApproveAnchorFamily(id)}
			size='sm'
		>
			{isPending ? <Spinner /> : <CheckIcon />}
			{t('app.approve')}
		</Button>
	)
}
